import { Step } from "react-joyride";

const editPlantPageTourSteps: Step[] = [
  {
    target: ".tour-plant-name",
    content: "Here you will enter a local Plant you use to pull or deposit material.",
    skipScroll: true,
  },
  {
    target: ".tour-plant-phone",
    content: "Enter the Plant’s Phone Number",
    skipScroll: true,
  },
  {
    target: ".tour-plant-address",
    content: "Enter the Plant’s Address",
    skipScroll: true,
  },
  {
    target: ".tour-plant-material-rate",
    content: "Enter your price per ton for the material",
  },
];

export default editPlantPageTourSteps;
